import { Component, OnInit, Input } from '@angular/core';
import { ApirequestService } from '../../../../../services/apirequest/apirequest.service';
import { ApiurlsService } from '../../../../../services/api-urls/apiurls.service';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInDown } from 'ng-animate';
import { trigger, transition, useAnimation } from '@angular/animations';

@Component({
  selector: 'hybse-admin-demo-buyer-seller',
  templateUrl: './demo-buyer-seller.component.html',
  styleUrls: ['./demo-buyer-seller.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ]
})
export class DemoBuyerSellerComponent implements OnInit {

  public idUser;
  public demoWallets: any[];
  public demoBuyOrder: any[];
  public demoSellOrder: any[];
  public buyStatus: string;
  public errorMessage: string;
  public sellStatus: string;

  constructor(private _req: ApirequestService,
    private _url: ApiurlsService,
    private activatedRoute: ActivatedRoute,
    private router: Router) {
    this.idUser = localStorage.getItem('idUser');
  }

  ngOnInit() {
    this.getDemoUserWallets();
    this.getDemoBuyorder();
    this.getDemoSellorder();
  }

  private getDemoUserWallets(): void {
    let data = {
      data: { idUser: this.idUser }
    };
    this._req.fetchApiData(this._url.demoWalletsDetails, data).subscribe(
      (data) => {
        this.demoWallets = data['data'];
      }, (error) => {
      });
  }


  private getDemoBuyorder(): void {
    let data = {
      data: { idUser: this.idUser }
    };
    this._req.fetchApiData(this._url.userDemoBuyorderList, data).subscribe(
      (data) => {
        if (data) {
          let success = data['data'];
          let error = data['error'];
          if (success !== "") {
            this.demoBuyOrder = success;
            this.demoBuyOrder.forEach((item) => {
              if (item.isDeleted) {
                this.buyStatus = 'cancel';
              } else if (!item.isDeleted && !item.isMatched) {
                this.buyStatus = 'open order'
              } else {
                this.buyStatus = 'Matched'
              }
            });
          } else {
            this.errorMessage = error['Error Description']
          }
        }
      }, (error) => {
      });
  }

  private getDemoSellorder(): void {
    let data = {
      data: { idUser: this.idUser }
    };
    this._req.fetchApiData(this._url.userDemoSellorderList, data).subscribe(
      (data) => {
        if (data) {
          let success = data['data'];
          let error = data['error'];
          if (success !== "") {
            this.demoSellOrder = success;
            this.demoSellOrder.forEach((item) => {
              if (item.isDeleted) {
                this.sellStatus = 'cancel';
              } else if (!item.isDeleted && !item.isMatched) {
                this.sellStatus = 'open order'
              } else {
                this.sellStatus = 'close'
              }
            });
          } else {
            this.errorMessage = error['Error Description']
          }
        }
      }, (error) => {
      });
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/users/investor/edituser/demo-buyer-seller.component.ts